import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':previousFieldReportTypeId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:previousFieldReportTypeId`;

export const URL = (previousFieldReportTypeId: number): RouteDefinition => `${baseRoute}/${previousFieldReportTypeId}`;
